import React from "react";
import { PDFViewer, PDFDownloadLink } from "@react-pdf/renderer";
import StatementDocument from "./StatementDocument";
import { useLocation, useNavigate } from "react-router-dom";
import StatementAgeingDocument from "./StatementAgeingDocument";
import * as XLSX from "xlsx";

const StatementAgeingPreview = ({
  statementDataFromAPI,
  handleCloseStatement,
}) => {
  const location = useLocation();
  // const statementDataFromAPI = location.state?.statementData || [];
  console.log(
    "statementDataFromAPI in Ageing preview print:",
    statementDataFromAPI,
  );
  const limitedData = statementDataFromAPI?.apiData?.slice(0, 1000) || [];
  console.log("limitedData in ageing preview:", limitedData);

  const data = Array.isArray(limitedData) ? limitedData : [];
  console.log("data in ageing document:", data);
  const totalP1 = data.reduce((sum, item) => {
    return sum + Number(item?.P1 || 0);
  }, 0);
  const totalP2 = data.reduce((sum, item) => {
    return sum + Number(item?.P2 || 0);
  }, 0);
  const totalP3 = data.reduce((sum, item) => {
    return sum + Number(item?.P3 || 0);
  }, 0);
  const totalP4 = data.reduce((sum, item) => {
    return sum + Number(item?.P4 || 0);
  }, 0);
  const totalP5 = data.reduce((sum, item) => {
    return sum + Number(item?.P5 || 0);
  }, 0);
  const totalP6 = data.reduce((sum, item) => {
    return sum + Number(item?.P6 || 0);
  }, 0);
  const totalAmount = data.reduce((sum, item) => {
    return sum + Number(item?.AMOUNT || 0);
  }, 0);

  console.log("totalAmount::", totalAmount);
  console.log("P1::", totalP1);
  console.log("P2::", totalP2);
  console.log("P3::", totalP3);
  console.log("P4::", totalP4);
  console.log("P5::", totalP5);
  console.log("P6::", totalP6);

  const today = new Date().toLocaleDateString("en-GB", {
    day: "2-digit",
    month: "short",
    year: "numeric",
  });

  // // Mock data
  const statementData = {
    period: "Nov 01 2022 – Nov 05 2022",
    customer: {
      name: "Andrea Pitatini",
      address: "East Low",
      city: "City, Country - Zip",
    },
    account: {
      holder: "Nick Jonas",
      iban: "GB00P0556666HH92922",
      currency: "GBP",
    },
    summary: {
      opening: "GBP 500.00",
      closing: "GBP 10618.00",
    },
    transactions: [
      {
        date: "26/02/2024 03:08 PM",
        party: "Monzo (CLR8999559595)",
        type: "debit",
        amount: "GBP 4000",
        balance: "GBP 8000.00",
      },
      {
        date: "26/02/2024 03:08 PM",
        party: "Monzo (CLR8999559595)",
        type: "credit",
        amount: "GBP 2000",
        balance: "GBP 10000.00",
      },
      {
        date: "26/02/2024 03:08 PM",
        party: "Monzo (CLR8999559595)",
        type: "credit",
        amount: "GBP 2000",
        balance: "GBP 12000.00",
      },
    ],
  };

  const navigate = useNavigate();

  const onBack = () => {
    navigate("/statements");
  };


    const apiData = statementDataFromAPI?.apiData || [];
  console.log("Ageing Statement data from preview", apiData);

    const exportToExcel = () => {
      if (apiData.length === 0) {
        alert("No data available to export");
        return;
      }
  
      // Create a new workbook and worksheet
      const worksheet = XLSX.utils.json_to_sheet(apiData);
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, "Statement");
  
      // Generate buffer and trigger download
      XLSX.writeFile(workbook, "statement_export.xlsx");
    };

  return (
    <div className="mx-4">
      <div className="flex justify-between items-center">
        <h2 className="text-xl font-semibold my-4">Statement Ageing Preview</h2>
        <div className="flex gap-2">

        <button
            onClick={exportToExcel}
            className="bg-green-600 hover:bg-green-700 text-white px-4 py-1 rounded transition-colors"
          >
            Export to Excel
          </button>
        <button
          className="text-white px-2 py-1 rounded  bg-gray-800 hover:bg-black "
          // onClick={onBack}
          onClick={handleCloseStatement}
        >
          Back
        </button>
        </div>
 
      </div>

      <div className="flex flex-col items-center h-screen">
        {/* PDF Viewer */}
        <div className="w-full h-screen border border-gray-300 mb-4">
          <PDFViewer width="100%" height="100%">
            <StatementAgeingDocument
              statementDataFromAPI={data}
              todayDate={today}
              totalAmount={totalAmount}
              totalP1={totalP1}
              totalP2={totalP2}
              totalP3={totalP3}
              totalP4={totalP4}
              totalP5={totalP5}
              totalP6={totalP6}
              // statement={statementData}
              // accountData={statementDataFromAPI}
            />
          </PDFViewer>
        </div>

        {/* Download Button */}
        <div className="mt-4 mb-6">
          <PDFDownloadLink
            document={
              <StatementAgeingDocument
                statementDataFromAPI={data}
                todayDate={today}
                totalAmount={totalAmount}

                // statement={statementData}
              />
            }
            fileName="statement.pdf"
            className="bg-blue-500 text-white px-4 py-2 rounded"
          >
            {({ loading }) => (loading ? "Loading..." : "Download Statement")}
          </PDFDownloadLink>
        </div>
      </div>
    </div>
  );
};

export default StatementAgeingPreview;
